import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { NgChanges } from '../../utilities/angular-types.util';

@Component({
  selector: 'procure-children-badge',
  templateUrl: './children-badge.component.html',
  styleUrl: './children-badge.component.scss',
  imports: [MatTooltip],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChildrenBadge implements OnChanges {
  @Input() type = '';
  @Input() count = 0;

  tooltip?: string;

  ngOnChanges(changes: NgChanges<ChildrenBadge>): void {
    if (
      (changes.count &&
        changes.count.currentValue !== changes.count.previousValue) ||
      (changes.type && changes.type.currentValue !== changes.type.previousValue)
    ) {
      this.tooltip = this.getTooltip();
    }
  }

  private getTooltip(): string | undefined {
    return `${this.count} ${this.getLabel()}`;
  }

  private getLabel(): string | undefined {
    return {
      PROJ: ['Project', 'Projects'],
      RFRFQ: ['Request for RFQ', 'Request for RFQs'],
      RFQ: ['Request for Quotation', 'Request for Quotations'],
      QUOT: ['Quotation', 'Quotations'],
    }[this.type]?.[this.count === 1 ? 0 : 1];
  }
}
